<template>
  <div class="footer-component">
    <div class="footer-wrapper d-flex flex-md-row flex-column justify-md-space-between my-11 mx-4 mx-md-0">
      <div class="footer-container">
        <a :href="`https://bank.invicta.pl${$t('bank_invicta_path.home')}`" target="_blank" class="d-flex justify-start">
          <img src="../assets/svg/Invicta_bank_plodnosci_white.svg" class="mr-12 mb-md-0 mb-10"/>
        </a>
      </div>
      <div class="footer-container mb-6 mb-md-0">
        <div class="footer-header text-left mt-2">
          {{ $t("page.footer_bank_header") }}
        </div>
        <div class="footer-container-item text-left mt-6">
          <a :href="footer_be_a_parent_link" target="_blank">{{ $t("page.be_a_parent_label") }}</a>
        </div>
        <div class="footer-container-item text-left mt-3">
          <a :href="footer_be_a_cell_donor_link" target="_blank">{{ $t("page.be_a_cell_donor_label") }}</a>
        </div>
        <div class="footer-container-item text-left mt-3">
          <a :href="footer_be_a_semen_donor_link" target="_blank">{{ $t("page.be_a_semen_donor_label") }}</a>
        </div>
        <!-- <div class="footer-container-item text-left mt-3">
          <a :href="footer_about_link" target="_blank">{{ $t("page.footer_about_label") }}</a>
        </div> -->
        <div class="footer-container-item text-left mt-3">
          <a :href="footer_contact_link" target="_blank">{{ $t("page.contact_label") }}</a>
        </div>
      </div>
      <div class="footer-container mb-6 mb-md-0">
        <div class="footer-header text-left mt-2">
          {{ $t("page.footer_contact_header") }}
        </div>
        <div class="footer-container-item-bold text-left mt-6">
          {{ $t("page.footer_phone_line_label") }}
        </div>
        <div class="footer-container-item-bold text-left mt-1">
          <a href="tel:+48 (58) 58 58 800" target="_blank">+48 (58) 58 58 800</a>
        </div>
        <div class="footer-container-item text-left mt-1">
            {{ $t("date.monday_short") }}-{{ $t("date.friday_short") }}.: 7:00 - 20:00<br/>
            {{ $t("date.saturday_short") }}.: 7:00 - 15:00
        </div>
      </div>
      <div class="footer-container text-left">
        <div class="footer-header text-left mt-2 mb-5">
          {{ $t("page.footer_social_media_header") }}
        </div>
        <a class="social_icon mr-6" href="https://www.facebook.com/klinika.invicta" target="_blank">
          <img :src="facebook_icon"/>
        </a>
        <a class="social_icon mr-6" href="https://pl.linkedin.com/company/kliniki-i-laboratoria-medyczne-invicta" target="_blank">
          <img :src="linkedin_icon"/>
        </a>
        <a class="social_icon mr-6" href="https://www.instagram.com/klinika_invicta/" target="_blank">
          <img :src="instagram_icon"/>
        </a>
        <a class="social_icon mr-6" href="https://www.youtube.com/channel/UCcbzfYFEvHfsePiwqawS1Fw/featured" target="_blank">
          <img :src="youtube_icon"/>
        </a>
      </div>

      
    </div>
    <v-divider color="white"></v-divider>
    <div class="footer-items d-flex flex-md-row flex-column align-start align-md-center my-11 mx-4 mx-md-0">
      <div class="footer-item mr-md-6 mb-md-0 mb-6"><a :href="link_privacy" target="_blank">{{$t('page.privacy_policy_name')}}</a></div>
      <div class="footer-item mr-md-6 mb-md-0 mb-6"><a :href="link_info" target="_blank">{{$t('page.gdpr_policy_name')}}</a></div>
      <div class="footer-item mr-md-6 mb-md-0 mb-6"><a :href="link_service" target="_blank">{{$t('page.regulation_name')}}</a></div>
      <v-spacer v-if="!$vuetify.display.mobile"></v-spacer>
      <div class="footer-item provider_logo my-6 my-md-0"
        :class="[$vuetify.display.mobile ? 'w-100 d-flex flex-row justify-space-between': 'w-auto']">
        <img :src="paynow_logo" alt="Paynow" title="Paynow"/>
        <img :src="visa_logo" class="ml-0 ml-md-6" alt="Visa" title="Visa"/>
        <img :src="master_card_logo" class="ml-0 ml-md-6" alt="MasterCard" title="MasterCard"/>
      </div>
    </div>
  </div>
</template>
<script>
import { computed } from 'vue';

export default {
name: 'FooterComponent',
  computed: {
    link_privacy() { 
      return `https://bank.invicta.pl${ this.$t('bank_invicta_path.privacy_policy') }`;
    },
    link_info() { 
      return `https://bank.invicta.pl${ this.$t('bank_invicta_path.gdpr_policy') }`;
    },
    link_service() { 
      return `https://bank.invicta.pl${ this.$t('bank_invicta_path.terms_and_conditions') }`;
    },
    footer_be_a_parent_link() { 
      return `https://bank.invicta.pl${ this.$t('bank_invicta_path.planning_parenthood') }`;
    },
    footer_be_a_cell_donor_link() { 
      return `https://bank.invicta.pl${ this.$t('bank_invicta_path.become_egg_donor') }`;
    },
    footer_be_a_semen_donor_link() { 
      return `https://bank.invicta.pl${ this.$t('bank_invicta_path.become_sperm_donor') }`;
    },
    footer_about_link() { 
      return `https://bank.invicta.pl${ this.$t('bank_invicta_path.home') }`;
    },
    footer_contact_link() { 
      return `https://bank.invicta.pl${ this.$t('bank_invicta_path.contact') }`;
    }
  },
  setup() {
      const facebook_icon = computed({
        get: () => { return require('../assets/icons/facebook.svg');}
      })
      const linkedin_icon = computed({
        get: () => { return require('../assets/icons/linkedin.svg');}
      })
      const instagram_icon = computed({
        get: () => { return require('../assets/icons/instagram.svg');}
      })
      const youtube_icon = computed({
        get: () => { return require('../assets/icons/youtube.svg');}
      })
      const paynow_logo = computed({
        get: () => { return require('../assets/img/paynow_logo.png');}
      })
      const visa_logo = computed({
        get: () => { return require('../assets/img/visa_logo.png');}
      })
      const master_card_logo = computed({
        get: () => { return require('../assets/img/master_card_logo.png');}
      })
      return {
        facebook_icon,
        linkedin_icon,
        instagram_icon,
        youtube_icon,
        paynow_logo,
        visa_logo,
        master_card_logo,
      }
    },
}
</script>

<style lang="scss" scoped>
.footer-component {
  *{
    // box-shadow: 0px 0px 2px yellow inset;
  }
  width: 1200px;
  margin: 0 auto;
  img {
    max-width: 190px;
    height: 48px; 
  }
  .footer-container {
    width: 100%;
  }
}
.footer-container-item {
  @include nsb-font-container;
  font-size: 14px;
  line-height: 23px;
    color: white;
  a {
    color: white;
  }
}
.footer-container-item-bold {
  @include nsb-font-header-bold;
  font-size: 14px;
  line-height: 23px;
    color: white;
  a {
    color: white;
  }
}
.footer-header {
  @include nsb-gentium-bold;
  font-size: 23px;
  line-height: 26px;
  color: white;
}
.footer-item {
  @include nsb-font-container;
  font-size: 12px;
  line-height: 20px;
  a {
    color: white;
  }
  &.provider_logo {
    height: 24px;
    img {
      height: 24px;
    }
  }
}
.social_icon {
  display: inline-block;
  img {
    height: 20px;
  }
}

@media (min-width: 960px) {
  .footer-item {
    font-size: 12px;
    line-height: 20px;
  }
  .footer-component {
    .footer-container {
      width: 25%;
    }
  }
}
</style>